// src/main.js
import { createApp } from 'vue';
import App from './App.vue';

// Importa Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

createApp(App).mount('#app');
